export default {
  data () {
    return {
      collapsed: true,
      seeMoreButton: 'See more',
    }
  },
  methods: {
    seeMoreBtnText () {
      this.collapsed = !this.collapsed

      if (this.collapsed) {
        this.seeMoreButton = 'See more'
      } else {
        this.seeMoreButton = 'See less'
      }
    },
  },
  mouted () {
    this.seeMoreBtnText()
  },
}
